import { observable } from "@legendapp/state";

export const $isOpen = observable(false);
